module.exports = __webpack_public_path__ + "static/img/数据治理与资产化.1e4a7232.png";